import contract from '@mailobj-browser/front/js/contracts/contract.js'
import docs from './docs/docs.js'
import home from './home/home.js'

export default contract({
    docs,
    home
})